import { cn } from '@/lib/utils';

interface StepProgressBarProps {
  steps: { id: string; label: string }[];
  currentIndex: number;
  maxVisitedIndex?: number;
  canNavigateTo?: (index: number) => boolean;
  onStepClick?: (index: number) => void;
}

export function StepProgressBar({ steps, currentIndex, maxVisitedIndex = 0, canNavigateTo, onStepClick }: StepProgressBarProps) {
  const progress = steps.length > 1 ? (currentIndex / (steps.length - 1)) * 100 : 0;

  return (
    <div className="space-y-3">
      <div className="flex justify-between">
        {steps.map((step, i) => {
          const isVisited = i !== currentIndex && i <= maxVisitedIndex && !!onStepClick;
          const isBlocked = canNavigateTo ? !canNavigateTo(i) : false;
          const isClickable = isVisited && !isBlocked;
          return isVisited ? (
            <button
              key={step.id}
              type="button"
              onClick={() => isClickable && onStepClick(i)}
              className={cn(
                'text-xs font-medium transition-colors',
                isClickable
                  ? cn('cursor-pointer', i <= currentIndex ? 'text-emerald-600 hover:text-emerald-800' : 'text-slate-400 hover:text-slate-600')
                  : 'text-slate-400 cursor-not-allowed opacity-50'
              )}
            >
              {step.label}
            </button>
          ) : (
            <span
              key={step.id}
              className={cn(
                'text-xs font-medium transition-colors',
                i <= currentIndex ? 'text-emerald-600' : 'text-slate-400'
              )}
            >
              {step.label}
            </span>
          );
        })}
      </div>
      <div className="h-1 w-full rounded-full bg-slate-100">
        <div
          className="h-1 rounded-full bg-emerald-500 transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
